import { useTranslation } from 'react-i18next'

import { QA_NAME_CONFIRMATION } from '../../../../constants/qa'
import { ConfirmationModal } from '../../../Confirmation'
import { useRequestTableDocFlowActions } from '../useRequestTableDocFlowActions'
import { useRequestTableItemActions } from '../useRequestTableItemActions'
import { useRequestTableMassActionRequest } from '../useRequestTableMassActionRequest'
import { useRequestTableMassActions } from '../useRequestTableMassActions'

export function useRequestTableActions({
  excludeIds,
  filterValues,
  pageItems,
  pagination,
  selectAllPages,
  selected,
  selectedIds,
  sub,
  onCleanSelection,
  onCloseModal,
  onReload,
  onSetModal,
}) {
  const { t } = useTranslation()

  const {
    getHandleSubmitActionWithType,
    handleAttachRequests,
    isPerformingMassAction,
    massAction,
    runMassAction,
  } = useRequestTableMassActionRequest({
    excludeIds,
    filterValues,
    pagination,
    selectAllPages,
    selectedIds,
    sub,
    onCleanSelection,
    onCloseModal,
    onReload,
  })

  const {
    handleConnectDocFlowsToItem,
    handleConnectDocFlowsToSelected,
    handleCreateDocFlowForItem,
    handleCreateDocFlowForSelected,
  } = useRequestTableDocFlowActions({
    excludeIds,
    pageItems,
    runMassAction,
    selectAllPages,
    selected,
    selectedIds,
    onCloseModal,
    onReload,
    onSetModal,
  })

  function showConfirmModal({
    cancelText = t('Modal.CancelBtnKey'),
    submitText,
    onCancel = onCloseModal,
    ...restProps
  }) {
    onSetModal(
      <ConfirmationModal
        {...restProps}
        actionButtonsProps={{
          cancelText,
          submitText,
        }}
        qaName={QA_NAME_CONFIRMATION}
        onCancel={onCancel}
      />
    )
  }

  const { setItemAction } = useRequestTableItemActions({
    getHandleSubmitActionWithType,
    handleAttachRequests,
    handleConnectDocFlowsToItem,
    handleCreateDocFlowForItem,
    massAction,
    showConfirmModal,
    onCloseModal,
    onSetModal,
  })

  const { setMassAction } = useRequestTableMassActions({
    excludeIds,
    filterValues,
    getHandleSubmitActionWithType,
    handleAttachRequests,
    handleConnectDocFlowsToSelected,
    handleCreateDocFlowForSelected,
    massAction,
    selectAllPages,
    selectedIds,
    showConfirmModal,
    sub,
    onCloseModal,
    onSetModal,
  })

  return { isPerformingMassAction, setItemAction, setMassAction }
}
